import {Component, ViewChild} from '@angular/core';
import {FormControl, FormGroup, ReactiveFormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {ToastrService} from 'ngx-toastr';
import {NgSelectModule} from "@ng-select/ng-select";
import {NgxDatatableModule} from "@swimlane/ngx-datatable";
import {ApiService} from "@ctms/api.service";
import {SpinnerComponent} from "@shared/components/spinner/spinner.component";
import {Page} from "@ctms/api/api.interfaces";
import {RouterLink} from "@angular/router";
import {NgbNavModule} from "@ng-bootstrap/ng-bootstrap";

@Component({
    selector: 'demo-patient-overview-records-tab',
    imports: [CommonModule, ReactiveFormsModule, SpinnerComponent, NgSelectModule, NgxDatatableModule, NgbNavModule],
    providers: [ApiService],
    templateUrl: './patient-overview.records-tab.component.html',
    standalone: true,
    styleUrl: './patient-overview.records-tab.component.scss'
})
export class DemoPatientOverviewRecordsTabComponent {
    errorMessage!: string;
    loading = false;

    @ViewChild("table") table: any;

    page: Page = {
        size: 10,
        start: 0,
        totalCount: 10
    };
    offset: number = 0
    rows: any[
    ]
    sortField: string = 'participantCode'
    order: string = 'asc'

    filterForm: FormGroup
    activeTab: number;
    buttonLabel: string;
    form: boolean = false

    constructor(
        public toastr: ToastrService,
    ) {
    }

    ngOnInit(): void {
        this.filterForm = new FormGroup({
            study: new FormControl(),
            site: new FormControl(),
            status: new FormControl(),
            lastName: new FormControl(),
            participantCode: new FormControl(),
            includesDemo: new FormControl(),
        });
    }

    reset(): void {

    }

    filter(): void {

    }

    setPage(pageInfo) {
        this.loading = true
        this.page.start = pageInfo.offset * this.page.size
        this.refreshRows()
    }

    sort(pageInfo) {
        this.loading = true
        this.sortField = pageInfo.sorts[0].prop
        this.order = pageInfo.sorts[0].dir
        this.table.offset = this.page.start
        this.refreshRows()
    }

    refreshRows() {

    }

    showForm() {
        this.form = true
    }

    closeForm() {
        this.form = false
    }

    tabChange(tabId: number) {
        this.form = false
        switch (tabId) {
            case 1:
                this.buttonLabel = "session note";
                this.rows = [
                    {
                        id: 1,
                        date: "03/09/2025",
                        time: "19:30 PM",
                        clinician: "Dr Rich Andrews",
                        type: "one"
                    },
                    {
                        id: 2,
                        date: "05/08/2025",
                        time: "11:30 AM",
                        clinician: "Dr Rich Andrews",
                        type: "two"
                    },
                ]
                break;
            case 2:
                this.buttonLabel = "general note";
                this.rows = [
                    {
                        id: 1,
                        date: "03/09/2025",
                        time: "19:30 PM",
                        clinician: "Dr Rich Andrews",
                        type: "one"
                    },
                    {
                        id: 2,
                        date: "11/08/2025",
                        time: "12:00 AM",
                        clinician: "Dr Rich Andrews",
                        type: "two"
                    },
                    {
                        id: 3,
                        date: "13/08/2025",
                        time: "10:30 AM",
                        clinician: "Dr Rich Andrews",
                        type: "two"
                    },
                ]
                break;
            case 3:
                this.buttonLabel = "risk";
                this.rows = [
                    {
                        id: 1,
                        date: "01/09/2025",
                        time: "17:30 PM",
                        clinician: "Dr Rich Andrews",
                        type: "one"
                    }
                ]
        }
    }

}
